// extracted by mini-css-extract-plugin
module.exports = {"oas-3-support-message":"oas-3-support-message-1d7vE","oas3SupportMessage":"oas-3-support-message-1d7vE"};